module.exports = __webpack_public_path__ + "af9637093649aa0bf6bc5683759990ae.jpg";